import api from './api'
import { Query } from '../model/Query'
import {
    createQueryString, respToEntidade, toEntidades, toEntidadeServer
} from './utils'
import TipoEntidade from '../model/TipoEntidade'
import { AreaDeAtuacao, Entidade } from '../model/Entidade'
import Localizacao from '../model/Localizacao'
import { CountTipo } from '../model/CountTipo'

async function get(query: Query) {
    const params = createQueryString(query)
    try {
        const res = await api.get(`/entidades/?${params}`)
        const newData = toEntidades(res.data.results)
        return Promise.resolve(
            { items: newData, total: res.data.count }
        )
    } catch (erro) {
        // TODO
        return Promise.reject(erro)
    }
}

async function getById(id: number) {
    try {
        const res = await api.get(`/entidades/${id}/`)
        const newData = respToEntidade(res.data)
        return Promise.resolve(newData)
    } catch (erro) {
        // TODO
        return Promise.reject(erro)
    }
}

async function save(entidade: Entidade) {
    const payload = toEntidadeServer(entidade)

    try {
        const res = await api.post('/entidades/', payload)
        return Promise.resolve(res.data)
    } catch (error) {
        // TODO
        return Promise.reject(error)
    }
}

const update = async (id: number, ent: Entidade) => {
    const payload = toEntidadeServer(ent)
    try {
        const res = await api.put(`/entidades/${id}/`, payload)
        return Promise.resolve(res.data)
    } catch (error) {
        // TODO
        return Promise.reject(error)
    }
}

const remove = async (id: number) => {
    try {
        const res = await api.delete(`/entidades/${id}/`)
        return Promise.resolve(res.data)
    } catch (error) {
        // TODO
        return Promise.reject(error)
    }
}

async function getTipoEntidades() {
    try {
        const res = await api.get<TipoEntidade[]>('/tipoEntidades/')
        return Promise.resolve(res.data)
    } catch (error) {
        // TODO
        return Promise.reject(error)
    }
}

async function getLocalizacoes() {
    try {
        const res = await api.get<Localizacao[]>('/localizacoes/')
        return Promise.resolve(res.data)
    } catch (error) {
        // TODO
        return Promise.reject(error)
    }
}

async function getAreasAtuacao() {
    try {
        const res = await api.get<AreaDeAtuacao[]>('/areaDeAtuacao/')
        return Promise.resolve(res.data)
    } catch (error) {
        // TODO
        return Promise.reject(error)
    }
}

async function getCountTipos() {
    try {
        const res = await api.get<CountTipo[]>('/entidades/count_tipo/')
        return Promise.resolve(res.data)
    } catch (error) {
        // TODO
        return Promise.reject(error)
    }
}

export default {
    get,
    getById,
    save,
    update,
    remove,
    getLocalizacoes,
    getTipoEntidades,
    getAreasAtuacao,
    getCountTipos
}
